export const todoQueryKeys = {
  all: ["todo"] as const,
  list: () => [...todoQueryKeys.all, "list"] as const,
  unreadCount: () => [...todoQueryKeys.all, "unreadCount"] as const,
}
